import { useDispatch, useStore } from 'react-redux'
import { setUserAction } from '@/store/actions/auth'
import { TUser } from '@/types/data/user'
import { TSession } from '@/types/v2'

export const useAuth = () => {
  const dispatch = useDispatch()

  const setSession = (user: TUser, jwt: any) => {
    dispatch(setUserAction(user, jwt))
  }

  const store = useStore()
  const session = store.getState()

  return { setSession, session: session as TSession }
}
